export default __webpack_public_path__ + "static/media/etacLionThumbnail.4744adb4.jpg";